import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IReview } from '../types';
import { ReviewRow } from './review-row';
import { useAuthRole } from '@app/utils';

interface Props {
  tableProps: TableProps;
  rows?: IReview[];
  loading?: boolean;
  isTLSelected?: boolean;
}

const ReviewList = ({ tableProps, rows, loading, isTLSelected }: Props) => {
  const { isManager, isSuperAdmin } = useAuthRole();

  const managerTableHead = [
    { id: 'behaviour', label: 'Behaviour', align: 'center', sortable: false },
    { id: 'taskPerformance', label: 'Task Performance', align: 'center', sortable: false },
    { id: 'projectInvolvement', label: 'Project Involvement', align: 'center', sortable: false },
    { id: 'communicationSkills', label: 'Communication Skills', align: 'center', sortable: false },
    { id: 'learningSkills', label: 'Learning Skills', align: 'center', sortable: false },
    { id: 'disciplineManners', label: 'Discipline and Manners', align: 'center', sortable: false },
  ];
  const teamLeadTableHead = [
    { id: 'behaviour', label: 'Behaviour', align: 'center', sortable: false },
    {
      id: 'decisionMakingSkills',
      label: 'Decision Making Skills',
      align: 'center',
      sortable: false,
    },
    { id: 'leadershipSkills', label: 'Leadership Skills', align: 'center', sortable: false },
    { id: 'communicationSkills', label: 'Communication Skills', align: 'center', sortable: false },
    { id: 'fairTreatment', label: 'Fair Treatment', align: 'center', sortable: false },
    { id: 'disciplineManners', label: 'Discipline and Manners', align: 'center', sortable: false },
  ];

  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    ...(isSuperAdmin
      ? [{ id: 'reviewFrom', label: 'Review From', align: 'center', sortable: false }]
      : []),
    { id: 'reviewTo', label: 'Review To', align: 'center', sortable: false },
    { id: 'dateAndTime', label: 'Date & Time', align: 'center', sortable: false },
    ...(isManager || !isTLSelected ? managerTableHead : teamLeadTableHead),
    { id: 'overallRating', label: 'Overall Rating', align: 'center', sortable: false },
    { id: 'description', label: 'Description', align: 'center', sortable: false },
    { id: 'action', label: 'Action', align: 'center', sortable: false },
  ];

  return (
    <PaginatedTable<IReview>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <ReviewRow
          row={row}
          selected={tableProps.selected.includes(row.id)}
          isTLSelected={isTLSelected}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};
export { ReviewList };
